package com.wintermar.inspection.core.ui.component.button.variant

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp

data class ButtonVariantModel(
    val stateColor: ButtonPaletteStateModel,
    val size: ButtonSizeModel
)

data class ButtonPaletteStateModel(
    val default: ButtonPaletteModel,
    val disabled: ButtonPaletteModel,
)

data class ButtonPaletteModel(
    val backgroundColor: Color,
    val textColor: Color,
    val borderColor: Color = Color.Unspecified,
    val iconColor: Color,
)

data class ButtonSizeModel(
    val height: Dp,
    val verticalPadding: Dp,
    val horizontalPadding: Dp
)
